export interface SubregionPillProps {
  label: string;
  color: string;
  /** Drawn switched off, with the label struck through. */
  hidden: boolean;
  onToggle: () => void;
}

/** One sub-region in a `SubregionLegend`: a coloured pill that shows or hides it. */
export function SubregionPill({ label, color, hidden, onToggle }: SubregionPillProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={!hidden}
      title={hidden ? `Show ${label}` : `Hide ${label}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '4px 9px',
        borderRadius: 999,
        border: `1px solid ${hidden ? 'var(--nb-border)' : 'transparent'}`,
        background: hidden ? 'transparent' : 'var(--nb-surface)',
        opacity: hidden ? 0.45 : 1,
        fontSize: 10.5,
        fontWeight: 600,
        color: hidden ? 'var(--nb-subtle)' : 'var(--nb-ink-2)',
        cursor: 'pointer',
        transition: 'opacity .12s, background .12s',
      }}
    >
      <i
        style={{
          width: 8,
          height: 8,
          borderRadius: 2,
          background: color,
          opacity: hidden ? 0.5 : 1,
        }}
      />
      <span style={{ textDecoration: hidden ? 'line-through' : 'none' }}>{label}</span>
    </button>
  );
}
